export const offlineDeviceServiceImplFactory = ({
  offlineDeviceRepository,
}: {
  offlineDeviceRepository: IOfflineDeviceRepository;
}) => {
  const getOfflineDevicelist: IGetOfflineDeviceService = async ({
    clinicId,
    floorIds,
  }) => {
    try {
      const response = await offlineDeviceRepository.getOfflineDevicelist({
        clinic_id: clinicId,
        floor_ids: floorIds,
      });

      return {
        success: true,
        data: response,
      };
    } catch (error) {
      return {
        success: false,
        error: { message: (error as unknown as Error).message },
      };
    }
  };

  const postDeviceIssue: IPostDeviceIssueService = async ({
    clinicId,
    deviceId,
    roomName,
    issues,
    comments,
    pictures,
  }) => {
    try {
      const response = await offlineDeviceRepository.postDeviceIssue({
        clinic_id: clinicId,
        device_id: deviceId,
        room_name: roomName,
        issues,
        comments,
        pictures,
      });

      if (!response) {
        throw new Error("Failed to report device issue");
      }

      return {
        success: true,
        data: response,
      };
    } catch (error) {
      return {
        success: false,
        error: { message: (error as unknown as Error).message },
      };
    }
  };

  const getAllDevicelistService: IGetAllDeviceService = async ({
    clinicId,
    floorIds,
  }) => {
    try {
      const response = await offlineDeviceRepository.getAllDevicelistAPI({
        clinic_id: clinicId,
        floor_ids: floorIds,
        status: 1,
      });

      return {
        success: true,
        data: response,
      };
    } catch (error) {
      return {
        success: false,
        error: { message: (error as unknown as Error).message },
      };
    }
  };

  return { getOfflineDevicelist, getAllDevicelistService, postDeviceIssue };
};
